import academicCalendar from './academicCalendar';

export default {
  academicCalendar,
};
